// ---------- filet de sécurité global : si un script plante, tout s'affiche ----------
window.addEventListener('error', function(){
  document.querySelectorAll('.reveal, .reveal-stag, .exp, .pb-title').forEach(function(el){ el.classList.add('in'); });
  var l = document.getElementById('loader'); if(l) l.remove();
});

// ---------- réutilisation des photos embarquées (zéro duplication) ----------
document.querySelectorAll('[data-src-from]').forEach(el => {
  const srcEl = document.getElementById(el.dataset.srcFrom);
  if(srcEl) el.src = srcEl.src;
});

// ---------- lien de téléchargement : App Store vs Google Play ----------
(function(){
  const link = document.getElementById('app-download-link');
  const tag = document.getElementById('app-download-tag');
  if(!link) return;
  const ua = navigator.userAgent || navigator.vendor || window.opera || '';
  const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
  link.href = isIOS ? link.dataset.ios : link.dataset.android;
  if(tag){
    const storeName = isIOS ? 'l\'App Store' : 'Google Play';
    tag.innerHTML = '<span class="dot"></span>Télécharger sur ' + storeName + ' ↗';
  }
})();

// ---------- loader d'entrée ----------
(function(){
  const loader = document.getElementById('loader');
  if(!loader) return;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){ loader.remove(); return; }
  const pct = loader.querySelector('.loader-pct');
  const t0 = performance.now(), DUR = 850;
  function tick(now){
    const p = Math.min(1, (now - t0) / DUR);
    pct.textContent = Math.round(p * 100) + '%';
    if(p < 1){ requestAnimationFrame(tick); }
    else {
      loader.classList.add('done');
      setTimeout(() => loader.remove(), 750);
    }
  }
  requestAnimationFrame(tick);
})();

// Filet de sécurité : si IntersectionObserver n'existe pas, tout s'affiche immédiatement
if(!('IntersectionObserver' in window)){
  window.IntersectionObserver = class {
    constructor(cb){ this.cb = cb; }
    observe(el){ this.cb([{ isIntersecting: true, target: el }], this); }
    unobserve(){}
  };
}

// ---------- mobile nav drawer ----------
const burger = document.getElementById('burger');
const navLinksPanel = document.getElementById('nav-links');
const navBackdrop = document.getElementById('nav-backdrop');

function closeMobileNav(){
  burger.classList.remove('open');
  burger.setAttribute('aria-expanded', 'false');
  navLinksPanel.classList.remove('open');
  navBackdrop.classList.remove('open');
  document.body.style.overflow = '';
}
function openMobileNav(){
  burger.classList.add('open');
  burger.setAttribute('aria-expanded', 'true');
  navLinksPanel.classList.add('open');
  navBackdrop.classList.add('open');
  document.body.style.overflow = 'hidden';
}
burger.addEventListener('click', () => {
  if(navLinksPanel.classList.contains('open')) closeMobileNav();
  else openMobileNav();
});
navBackdrop.addEventListener('click', closeMobileNav);
document.querySelectorAll('#nav-links a').forEach(a => a.addEventListener('click', closeMobileNav));
document.addEventListener('keydown', (e) => { if(e.key === 'Escape') closeMobileNav(); });
window.addEventListener('resize', () => { if(window.innerWidth > 900) closeMobileNav(); });

// ---------- header scroll state + active nav link ----------
const header = document.getElementById('site-header');
const navLinks = document.querySelectorAll('[data-nav]');
const sections = ['club','terrains','plans','offres','tournois','reserver','avis','partenaires','infos'].map(id => document.getElementById(id)).filter(Boolean);

// ---------- navigation par ancre robuste (évite le saut en haut) ----------
(function(){
  const headerEl = document.querySelector('header');
  function scrollToHash(hash){
    const target = document.getElementById(hash.slice(1));
    if(!target) return false;
    // révèle tout contenu encore masqué à l'intérieur pour figer la hauteur avant de calculer la position
    target.querySelectorAll('.reveal, .reveal-stag, .exp, .pb-title').forEach(el => el.classList.add('in'));
    const menuOpen = document.getElementById('nav-links') && document.getElementById('nav-links').classList.contains('open');
    // laisse le menu se fermer et le layout se stabiliser puis défile vers la bonne position
    setTimeout(() => {
      const offset = (headerEl ? headerEl.offsetHeight : 0) + 12;
      const y = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }, menuOpen ? 260 : 20);
    return true;
  }
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', (e) => {
      const hash = a.getAttribute('href');
      if(hash.length < 2) return;
      if(document.getElementById(hash.slice(1))){
        e.preventDefault();
        scrollToHash(hash);
        history.replaceState(null, '', hash);
      }
    });
  });
})();

window.addEventListener('scroll', () => {
  header.classList.toggle('scrolled', window.scrollY > 40);
  let current = null;
  sections.forEach(sec => {
    const rect = sec.getBoundingClientRect();
    if(rect.top <= 120 && rect.bottom >= 120) current = sec.id;
  });
  navLinks.forEach(a => a.classList.toggle('active', a.getAttribute('href') === '#' + current));
}, { passive:true });

// ---------- reveal on scroll ----------
const revealEls = document.querySelectorAll('.reveal, .reveal-stag');
const io = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if(entry.isIntersecting){
      entry.target.classList.add('in');
      io.unobserve(entry.target);
    }
  });
}, { threshold:0.15 });
revealEls.forEach(el => io.observe(el));

// ---------- animated stat counters ----------
const counters = document.querySelectorAll('[data-count]');
const cio = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if(!entry.isIntersecting) return;
    const el = entry.target;
    const target = parseFloat(el.dataset.count);
    const decimals = parseInt(el.dataset.decimals || '0');
    const duration = 1200;
    const start = performance.now();
    function tick(now){
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toFixed(decimals).replace('.', ',');
      if(p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
    cio.unobserve(el);
  });
}, { threshold:0.6 });
counters.forEach(el => cio.observe(el));

// ---------- gallery parallax ----------
const parallaxImgs = document.querySelectorAll('[data-parallax]');
if(parallaxImgs.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && window.matchMedia('(min-width: 769px)').matches){
  let ticking = false;
  function applyParallax(){
    const vh = window.innerHeight;
    parallaxImgs.forEach(img => {
      const rect = img.getBoundingClientRect();
      if(rect.bottom < 0 || rect.top > vh) return;
      const progress = (rect.top + rect.height / 2 - vh / 2) / vh; // -0.5..0.5 env.
      const strength = parseFloat(img.dataset.parallax) * 100;
      img.style.transform = `scale(1.12) translateY(${(-progress * strength).toFixed(1)}px)`;
    });
    ticking = false;
  }
  window.addEventListener('scroll', () => {
    if(!ticking){ requestAnimationFrame(applyParallax); ticking = true; }
  }, { passive:true });
  applyParallax();
}

// ---------- court plan: tabs + presentation-style reveal ----------
const bpTabs = document.querySelectorAll('.bp-tab');
const bpViews = document.querySelectorAll('.bp-view');
const bpCaption = document.getElementById('bp-caption');
const bpCaptions = {
  ensemble: "Un terrain vitré fermé, symétrique de part et d'autre du filet.",
  zones: "Lignes de service à 6,5 m du filet, formant deux carrés de service identiques de 5 m de chaque côté de la piste.",
  dimensions: "20 m de long, 10 m de large, lignes de service à 6,5 m du filet, carrés de service de 5 m."
};
bpTabs.forEach(tab => tab.addEventListener('click', (e) => {
  e.preventDefault();
  bpTabs.forEach(t => t.classList.remove('active'));
  tab.classList.add('active');
  const view = tab.dataset.view;
  bpViews.forEach(v => v.classList.toggle('active', v.id === 'view-' + view));
  bpCaption.textContent = bpCaptions[view];
}));

// draw-in animation for SVG line diagrams, triggered once per stage on scroll into view
function setupDrawStage(stageSelector){
  const stage = document.querySelector(stageSelector);
  if(!stage) return;
  const els = stage.querySelectorAll('.bp-draw');
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if(entry.isIntersecting){
        els.forEach((el, i) => {
          const len = el.getTotalLength ? el.getTotalLength() : 400;
          el.style.strokeDasharray = len;
          el.style.strokeDashoffset = len;
          setTimeout(() => { el.style.strokeDashoffset = '0'; }, i * 70 + 30);
        });
        io.unobserve(entry.target);
      }
    });
  }, { threshold:0.35 });
  io.observe(stage);
}
setupDrawStage('.blueprint-stage');

// ---------- offers tabs ----------
const offerTabs = document.querySelectorAll('.offer-tab');
const offerPanels = document.querySelectorAll('.offers-panel');
const offerTabsBar = document.getElementById('offers-tabs');
offerTabs.forEach(tab => tab.addEventListener('click', (e) => {
  e.preventDefault();
  // mémorise la position à l'écran de la barre d'onglets
  const anchor = offerTabsBar || tab;
  const before = anchor.getBoundingClientRect().top;
  offerTabs.forEach(t => t.classList.remove('active'));
  tab.classList.add('active');
  offerPanels.forEach(p => p.classList.toggle('active', p.id === 'panel-' + tab.dataset.panel));
  // après le changement de panneau, corrige tout décalage pour garder les onglets au même endroit
  const after = anchor.getBoundingClientRect().top;
  const delta = after - before;
  if(delta !== 0){ window.scrollBy(0, delta); }
}));

// ---------- tarifs / abonnements : accordéon horizontal ----------
document.querySelectorAll('.tarif-accordion').forEach(acc => {
  const slabs = acc.querySelectorAll('.tarif-slab');
  if(!slabs.length) return;
  const canHover = window.matchMedia('(hover: hover)').matches;
  function open(target){ slabs.forEach(s => s.classList.toggle('is-open', s === target)); }
  slabs.forEach(slab => {
    if(canHover){ slab.addEventListener('mouseenter', () => open(slab)); }
    slab.addEventListener('click', () => open(slab));
    slab.addEventListener('keydown', (e) => {
      if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); open(slab); }
    });
  });
});

// ---------- review carousel ----------
const track = document.getElementById('review-track');
const cards = track.children;
const dotsWrap = document.getElementById('car-dots');
let perView = window.innerWidth <= 900 ? 1 : 3;
let index = 0;

function maxIndex(){ return Math.max(0, cards.length - perView); }

function buildDots(){
  dotsWrap.innerHTML = '';
  for(let i=0; i <= maxIndex(); i++){
    const d = document.createElement('button');
    d.className = 'car-dot' + (i === index ? ' active' : '');
    d.addEventListener('click', () => { index = i; update(); });
    dotsWrap.appendChild(d);
  }
}

function update(){
  const cardWidth = cards[0].getBoundingClientRect().width;
  const gap = 24;
  track.style.transform = `translateX(-${index * (cardWidth + gap)}px)`;
  [...dotsWrap.children].forEach((d,i) => d.classList.toggle('active', i === index));
}

document.getElementById('car-prev').addEventListener('click', () => {
  index = Math.max(0, index - 1); update();
});
document.getElementById('car-next').addEventListener('click', () => {
  index = Math.min(maxIndex(), index + 1); update();
});

window.addEventListener('resize', () => {
  perView = window.innerWidth <= 900 ? 1 : 3;
  index = Math.min(index, maxIndex());
  buildDots();
  update();
});

buildDots();
update();

// ---------- 3D padel court (Tournois section) ----------
(function(){
  const container = document.getElementById('court3d');
  if(!container || typeof THREE === 'undefined') return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(42, container.clientWidth / container.clientHeight, 0.1, 100);
  camera.position.set(0, 6.5, 9.5);
  camera.lookAt(0, 0, 0);

  const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
  renderer.setSize(container.clientWidth, container.clientHeight);
  container.appendChild(renderer.domElement);

  scene.add(new THREE.AmbientLight(0xffffff, 0.7));
  const keyLight = new THREE.DirectionalLight(0xffffff, 0.85);
  keyLight.position.set(6, 10, 6);
  scene.add(keyLight);
  const rimLight = new THREE.DirectionalLight(0x4253fa, 0.5);
  rimLight.position.set(-7, 4, -5);
  scene.add(rimLight);

  const courtGroup = new THREE.Group();
  scene.add(courtGroup);

  // floor — gazon noir façon "pro", comme au club
  const floor = new THREE.Mesh(
    new THREE.PlaneGeometry(10, 5),
    new THREE.MeshStandardMaterial({ color: 0x0a0a0e, roughness: 0.95, metalness: 0.02 })
  );
  floor.rotation.x = -Math.PI / 2;
  courtGroup.add(floor);

  function addLine(x1, z1, x2, z2, color, opacity, width){
    const length = Math.hypot(x2 - x1, z2 - z1);
    const geo = new THREE.BoxGeometry(length, 0.015, width);
    const mat = new THREE.MeshBasicMaterial({ color, transparent: true, opacity });
    const mesh = new THREE.Mesh(geo, mat);
    mesh.position.set((x1 + x2) / 2, 0.012, (z1 + z2) / 2);
    mesh.rotation.y = -Math.atan2(z2 - z1, x2 - x1);
    courtGroup.add(mesh);
  }

  // boundary
  addLine(-5, -2.5, 5, -2.5, 0xffffff, 0.55, 0.025);
  addLine(-5, 2.5, 5, 2.5, 0xffffff, 0.55, 0.025);
  addLine(-5, -2.5, -5, 2.5, 0xffffff, 0.55, 0.025);
  addLine(5, -2.5, 5, 2.5, 0xffffff, 0.55, 0.025);
  // service lines — à 6,5 m du filet
  addLine(-3.25, -2.5, -3.25, 2.5, 0xffffff, 0.4, 0.02);
  addLine(3.25, -2.5, 3.25, 2.5, 0xffffff, 0.4, 0.02);
  // ligne centrale — délimite deux carrés de service de 5 m
  addLine(-3.25, 0, 0, 0, 0xffffff, 0.4, 0.02);
  addLine(0, 0, 3.25, 0, 0xffffff, 0.4, 0.02);

  // glass walls
  const glassMat = new THREE.MeshPhysicalMaterial({
    color: 0x4253fa, transparent: true, opacity: 0.16, roughness: 0.15, metalness: 0, side: THREE.DoubleSide
  });
  const backGeo = new THREE.PlaneGeometry(5, 1.6);
  const back1 = new THREE.Mesh(backGeo, glassMat);
  back1.position.set(-5, 0.8, 0);
  back1.rotation.y = Math.PI / 2;
  courtGroup.add(back1);
  const back2 = back1.clone();
  back2.position.set(5, 0.8, 0);
  courtGroup.add(back2);

  const sideGeo = new THREE.PlaneGeometry(2.2, 1.6);
  [[-3.9, -2.5], [3.9, -2.5], [-3.9, 2.5], [3.9, 2.5]].forEach(([x, z]) => {
    const m = new THREE.Mesh(sideGeo, glassMat);
    m.position.set(x, 0.8, z);
    courtGroup.add(m);
  });

  // net — filet blanc quadrillé, bande supérieure avec inscriptions HOME PADEL en bleu
  function makeNetTexture(){
    const cw = 1024, ch = 128;
    const cnv = document.createElement('canvas');
    cnv.width = cw; cnv.height = ch;
    const ctx = cnv.getContext('2d');

    // maillage du filet
    ctx.strokeStyle = 'rgba(255,255,255,0.85)';
    ctx.lineWidth = 1.4;
    const step = 14;
    for(let x = 0; x <= cw; x += step){
      ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x, ch); ctx.stroke();
    }
    for(let y = 0; y <= ch; y += step){
      ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(cw, y); ctx.stroke();
    }

    // bande supérieure blanche
    const bandH = 26;
    ctx.fillStyle = '#FFFFFF';
    ctx.fillRect(0, 0, cw, bandH);

    // petites inscriptions HOME PADEL en bleu, répétées le long de la bande
    ctx.fillStyle = '#4253FA';
    ctx.font = '700 15px Arial, sans-serif';
    ctx.textBaseline = 'middle';
    const label = 'HOME PADEL';
    const labelW = ctx.measureText(label).width;
    const gap = 70;
    for(let x = 30; x < cw - labelW; x += labelW + gap){
      ctx.fillText(label, x, bandH / 2 + 1);
    }

    const tex = new THREE.CanvasTexture(cnv);
    tex.anisotropy = 4;
    return tex;
  }

  const net = new THREE.Mesh(
    new THREE.PlaneGeometry(5, 0.5),
    new THREE.MeshBasicMaterial({ map: makeNetTexture(), transparent: true, side: THREE.DoubleSide })
  );
  net.position.set(0, 0.25, 0);
  net.rotation.y = Math.PI / 2;
  courtGroup.add(net);

  // corner posts
  const postMat = new THREE.MeshStandardMaterial({ color: 0x8fa3f0, roughness: 0.4 });
  [[-5, -2.5], [5, -2.5], [-5, 2.5], [5, 2.5]].forEach(([x, z]) => {
    const post = new THREE.Mesh(new THREE.CylinderGeometry(0.04, 0.04, 1.6, 8), postMat);
    post.position.set(x, 0.8, z);
    courtGroup.add(post);
  });

  courtGroup.rotation.y = -0.5;

  // ---------- banderole partenaire principal : PEUGEOT MEAUX ----------
  function makeBannerTexture(){
    const cw = 1024, ch = 160;
    const cnv = document.createElement('canvas');
    cnv.width = cw; cnv.height = ch;
    const ctx = cnv.getContext('2d');
    ctx.fillStyle = '#0a0a0a';
    ctx.fillRect(0, 0, cw, ch);
    ctx.strokeStyle = 'rgba(255,255,255,0.25)';
    ctx.lineWidth = 4;
    ctx.strokeRect(8, 8, cw - 16, ch - 16);
    ctx.fillStyle = '#FFFFFF';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.font = '700 72px Arial, sans-serif';
    ctx.fillText('PEUGEOT MEAUX', cw / 2, ch / 2 - 14);
    ctx.fillStyle = '#8FA3F0';
    ctx.font = '600 26px Arial, sans-serif';
    ctx.fillText('PARTENAIRE PRINCIPAL', cw / 2, ch / 2 + 42);
    const tex = new THREE.CanvasTexture(cnv);
    tex.anisotropy = 4;
    return tex;
  }
  const bannerTex = makeBannerTexture();
  [2.48, -2.48].forEach((z, i) => {
    const banner = new THREE.Mesh(
      new THREE.PlaneGeometry(2.6, 0.4),
      new THREE.MeshBasicMaterial({ map: bannerTex, side: THREE.DoubleSide })
    );
    banner.position.set(0, 1.15, z);
    if(i === 1) banner.rotation.y = Math.PI;
    courtGroup.add(banner);
  });

  // ---------- 4 joueurs stylisés + balle en échange ----------
  const players = [];
  function makePlayer(shirtColor, x, z, facing){
    const g = new THREE.Group();

    const shirtMat = new THREE.MeshStandardMaterial({ color: shirtColor, roughness: 0.6 });
    const skinMat = new THREE.MeshStandardMaterial({ color: 0xd9b08c, roughness: 0.7 });
    const shortMat = new THREE.MeshStandardMaterial({ color: 0x10173a, roughness: 0.7 });

    // torse
    const torso = new THREE.Mesh(new THREE.CylinderGeometry(0.09, 0.11, 0.34, 10), shirtMat);
    torso.position.y = 0.52;
    g.add(torso);
    // tête
    const head = new THREE.Mesh(new THREE.SphereGeometry(0.075, 12, 10), skinMat);
    head.position.y = 0.78;
    g.add(head);
    // jambes
    const legGeo = new THREE.CylinderGeometry(0.035, 0.03, 0.34, 8);
    const legL = new THREE.Mesh(legGeo, shortMat);
    legL.position.set(-0.05, 0.18, 0);
    g.add(legL);
    const legR = legL.clone();
    legR.position.x = 0.05;
    g.add(legR);
    // bras libre
    const armGeo = new THREE.CylinderGeometry(0.025, 0.022, 0.28, 8);
    const armFree = new THREE.Mesh(armGeo, skinMat);
    armFree.position.set(-0.13, 0.55, 0);
    armFree.rotation.z = 0.5;
    g.add(armFree);
    // bras raquette (pivot à l'épaule pour l'animation de frappe)
    const armPivot = new THREE.Group();
    armPivot.position.set(0.12, 0.64, 0);
    const armSwing = new THREE.Mesh(armGeo, skinMat);
    armSwing.position.y = -0.13;
    armPivot.add(armSwing);
    // raquette de padel (tamis plein + manche)
    const racket = new THREE.Group();
    const face = new THREE.Mesh(
      new THREE.CylinderGeometry(0.085, 0.085, 0.02, 14),
      new THREE.MeshStandardMaterial({ color: 0x4253fa, roughness: 0.4 })
    );
    face.rotation.x = Math.PI / 2;
    const handle = new THREE.Mesh(
      new THREE.CylinderGeometry(0.015, 0.015, 0.1, 8),
      new THREE.MeshStandardMaterial({ color: 0x222222 })
    );
    handle.position.y = 0.13;
    racket.add(face); racket.add(handle);
    racket.position.y = -0.34;
    racket.rotation.x = Math.PI;
    armPivot.add(racket);
    armPivot.rotation.z = -0.9;
    g.add(armPivot);

    g.position.set(x, 0, z);
    g.rotation.y = facing;
    courtGroup.add(g);
    players.push({ group: g, armPivot, baseX: x, baseZ: z, phase: Math.random() * Math.PI * 2 });
    return g;
  }

  // équipe gauche (maillot bleu vif) / équipe droite (maillot blanc)
  makePlayer(0x4253fa, -3.6, -1.2,  Math.PI / 2);
  makePlayer(0x4253fa, -2.2,  1.2,  Math.PI / 2);
  makePlayer(0xf2f2f2,  3.6,  1.2, -Math.PI / 2);
  makePlayer(0xf2f2f2,  2.2, -1.2, -Math.PI / 2);

  // balle échangée entre les deux camps
  const ball = new THREE.Mesh(
    new THREE.SphereGeometry(0.055, 10, 8),
    new THREE.MeshStandardMaterial({ color: 0xd9e85c, roughness: 0.4 })
  );
  courtGroup.add(ball);
  ball.position.set(-3.2, 0.4, 0.3);
  let rallyT = 0;

  function onResize(){
    const w = container.clientWidth, h = container.clientHeight;
    if(w === 0 || h === 0) return;
    camera.aspect = w / h;
    camera.updateProjectionMatrix();
    renderer.setSize(w, h);
  }
  window.addEventListener('resize', onResize);

  // drag to rotate
  let dragging = false, lastX = 0, lastY = 0, autoRotate = !reduceMotion, idleTimer = null;
  const el = renderer.domElement;
  function pointerDown(e){
    dragging = true; autoRotate = false;
    lastX = e.clientX || (e.touches && e.touches[0].clientX);
    lastY = e.clientY || (e.touches && e.touches[0].clientY);
    clearTimeout(idleTimer);
  }
  function pointerMove(e){
    if(!dragging) return;
    const x = e.clientX || (e.touches && e.touches[0].clientX);
    const y = e.clientY || (e.touches && e.touches[0].clientY);
    const dx = x - lastX, dy = y - lastY;
    courtGroup.rotation.y += dx * 0.008;
    courtGroup.rotation.x = Math.max(-0.35, Math.min(0.35, courtGroup.rotation.x + dy * 0.005));
    lastX = x; lastY = y;
  }
  function pointerUp(){
    dragging = false;
    if(!reduceMotion) idleTimer = setTimeout(() => { autoRotate = true; }, 1800);
  }
  el.addEventListener('pointerdown', pointerDown);
  window.addEventListener('pointermove', pointerMove);
  window.addEventListener('pointerup', pointerUp);
  el.addEventListener('touchstart', pointerDown, { passive: true });
  el.addEventListener('touchmove', pointerMove, { passive: true });
  el.addEventListener('touchend', pointerUp);

  let rafId = null;
  function animate(){
    rafId = requestAnimationFrame(animate);
    if(autoRotate) courtGroup.rotation.y += 0.0035;

    // échange : la balle traverse le filet en cloche, aller-retour
    rallyT += 0.011;
    const cycle = (Math.sin(rallyT) + 1) / 2;          // 0 → 1 → 0
    ball.position.x = -3.2 + cycle * 6.4;               // d'un camp à l'autre
    ball.position.z = Math.sin(rallyT * 0.5) * 0.9;     // légère dérive latérale
    ball.position.y = 0.35 + Math.abs(Math.sin(rallyT)) * 1.1; // arc au-dessus du filet

    // joueurs : petits pas latéraux + frappe quand la balle arrive de leur côté
    const hitLeft = Math.max(0, -Math.cos(rallyT));     // pic quand la balle est à gauche
    const hitRight = Math.max(0, Math.cos(rallyT));     // pic quand la balle est à droite
    players.forEach((p, i) => {
      const t = rallyT * 1.6 + p.phase;
      p.group.position.z = p.baseZ + Math.sin(t) * 0.25;
      p.group.position.x = p.baseX + Math.cos(t * 0.7) * 0.12;
      const isLeftTeam = i < 2;
      const swing = isLeftTeam ? hitLeft : hitRight;
      p.armPivot.rotation.z = -0.9 + swing * 1.5;       // le bras se lève pour frapper
    });

    renderer.render(scene, camera);
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if(entry.isIntersecting){
        onResize();
        if(!rafId) animate();
      } else if(rafId){
        cancelAnimationFrame(rafId);
        rafId = null;
      }
    });
  }, { threshold: 0.1 });
  io.observe(container);

  if(reduceMotion){
    onResize();
    renderer.render(scene, camera);
  }
})();